/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */

/**
 *
 * @param defaultRoles default roles
 * @param roleId selected roles
 * @returns role objects with type property
 */
export const getRolesWithTypeProp = (defaultRoles: any, roleId: any) => {
  let defaultRoleValues: string[] = [];
  defaultRoleValues = defaultRoles.map((role: any) => role.value);

  let defaultRoleListPayload = [];
  defaultRoleListPayload = defaultRoleValues
    .map((defaultRoleValue) => {
      if (!roleId.includes(defaultRoleValue)) {
        return {
          roleId: defaultRoleValue,
          type: "remove",
        };
      }
    })
    .filter((value) => value);

  let newRoleIdsPayload = [];
  newRoleIdsPayload = roleId
    .filter((roleIds: any) => !defaultRoleValues.includes(roleIds))
    .map((value: any) => {
      return {
        roleId: value,
        type: "add",
      };
    });
  return [...defaultRoleListPayload, ...newRoleIdsPayload];
};
